module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-5.bc767668.png";